<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <card type="login" v-if="step === 'confirm'">
                <h3 slot="header" class="header text-center">{{$t('Reset password')}}</h3>
                <template v-if="statusResetPassword === 'fetching'">
                  <p v-loading="true" class="card-text"></p>
                  <br>
                </template>
                <template v-else-if="statusResetPassword === 'failure'">
                  <p class="card-text text-danger">{{$t('Password reset error')}}.</p>
                </template>
                <template v-else-if="statusResetPassword === 'success'">
                  <p class="card-text">{{$t('Password reset success')}}.</p>
                  <hr/>
                  <div>
                    <router-link :to="{ name: 'Login'}" tag="a">{{ $t('Login') }}</router-link>
                  </div>
                </template>
              </card>
              <card type="login" v-else>
                <form @submit.prevent="requestPasswordReset">
                  <h3 slot="header" class="header text-center">{{$t('Reset password')}}</h3>
                  <template v-if="statusForgotPassword === 'success'">
                    <p class="card-title">{{$t('Your request for password reset successfully submitted')}}.</p>
                    <p class="card-text">{{$t('Please check your e-mail')}}.</p>
                  </template>
                  <template v-else>
                    <p class="card-text text-danger" v-if="statusForgotPassword === 'failure'">{{$t('An error occurred')}}. {{$t('Please check if Login name is correct')}}.</p>
                    <p v-loading="requesting" class="card-text center"></p>
                    <br />
                    <fg-input v-model="form.username"
                              name="username"
                              v-validate="validations.username"
                              autocomplete="username"
                              :error="getError('username')"
                              addon-left-icon="nc-icon nc-single-02"
                              autofocus
                              :placeholder="$t('Username')"></fg-input>
                    <br>
                    <p-button native-type="submit" slot="footer" type="primary" round block :disabled="requesting" class="mb-3 btn-one-size">{{$t('Submit')}}</p-button>
                  </template>
                </form>
              </card>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div class="full-page-background" style="background-image: url(/static/img/sidebar.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card, Button } from 'src/components/UIComponents'
  import { mapActions, mapState } from 'vuex'
  import AppNavbar from './Layout/AppNavbar'
  import AppFooter from './Layout/AppFooter'

  export default {
    components: {
      AppNavbar,
      AppFooter,
      Card,
      [Button.name]: Button
    },
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open', 'off-canvas-sidebar')
      },
      ...mapActions('user', [
        'forgotPassword',
        'resetPassword',
        'reset'
      ]),
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      async requestPasswordReset () {
        if (await this.$validator.validateAll()) {
          await this.forgotPassword({ username: this.form.username })
        }
      }
    },
    data () {
      return {
        form: {
          username: ''
        },
        validations: {
          username: {
            required: true
          }
        }
      }
    },
    beforeDestroy () {
      this.closeMenu()
      this.reset()
    },
    computed: {
      ...mapState({
        statusForgotPassword: ({ user }) => user.statusForgotPassword,
        statusResetPassword: ({ user }) => user.statusResetPassword
      }),
      requesting: function () {
        return this.statusForgotPassword === 'fetching'
      },
      step: function () {
        return this.$route.name === 'PasswordResetConfirm' ? 'confirm' : 'request'
      }
    },
    mounted () {
      const { token } = this.$route.params
      if (this.step === 'confirm') {
        this.resetPassword({ token })
      } else {

      }
    },
    watch: {
      '$route.params.token' (token) {
        this.resetPassword({ token })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .btn-one-size {
    width: 100%;
  }
</style>
